import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-linejoin": "round",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M2.5 21.5v-19h19v19h-19Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M18.5 12a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M15.5 12a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.5 11.5V5.52A6.504 6.504 0 0 1 18.002 9.5l-5.502 2Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }